import { ID, TaskLinkFields, Timestamp } from '@griply/types';

import { taskGoalIds } from './links/task-link-ids';

type CompletedCalendarTask = TaskLinkFields & {
  parentIds?: string[] | null;
  archivedAt?: Timestamp | null;
};

// One live goal keeps the task visible; only an all-archived task drops out.
const isBehindArchivedGoals = (
  task: CompletedCalendarTask,
  archivedGoalIds: ID[],
): boolean => {
  const goalIds = taskGoalIds(task);

  return (
    !!goalIds.length &&
    goalIds.every((goalId) => archivedGoalIds.includes(goalId))
  );
};

// Mirrors the three drops the uncompleted calendar read gets from its filters.
export const filterCompletedCalendarTasks = <T extends CompletedCalendarTask>(
  tasks: T[],
  archivedGoalIds: ID[] = [],
): T[] =>
  tasks.filter(
    (task) =>
      !task.parentIds?.length &&
      !task.archivedAt &&
      !isBehindArchivedGoals(task, archivedGoalIds),
  );
